module.exports = __webpack_public_path__ + "img/9788958285144.e52e0a23.jpg";